const Vue = require('vue/dist/vue.js');
const VueDevice = require('./common/device');
const VueNotie = require('./common/notie');
class Entry {
	constructor() {
		if (!document.querySelector("#app")) {
			return
		}
		Vue.use(VueDevice);
		Vue.use(VueNotie)
		const vm = new Vue({
			el: "#app",
			components: {
				portfolio: require('./components/portfolio/portfolio.vue'),
				clientCase: require('./components/client-case/client-case.vue')
			}
		})
	}
}
module.exports = Entry